<div id="loader" class="absolute w-full h-full bg-white flex flex-col justify-center items-center animate__animated fast-animation" 
    [class]="classIsClosing + classZIndex">
    <div class="loader"></div>
    <p class="mt-10 text-principal-700">{{ message }}</p>
</div>